import type { ReactElement } from 'react';
import { Children, cloneElement, memo } from 'react';

import { MultiProgressBarStyled } from './styles/MultiProgressBarStyled'
import { MultiProgressLineStyled } from './styles/MultiProgressLineStyled'
import { MultiProgressStyled } from './styles/MultiProgressStyled'
import { type IProgressProps, Progress } from '../Progress'
import { SubText } from '../Text'

interface MultiProgressLine {
  label: string
  position: number
}

export interface IMultiProgressProps {
  height?: string | number
  lines?: MultiProgressLine[]
  children?:
    | ReactElement<IProgressProps>[]
    | ReactElement<IProgressProps>
}

const renderMultiProgressLines = (lines: IMultiProgressProps['lines']) => {
  return lines.map((line) => {
    return (
      <MultiProgressLineStyled
        key={line.label}
        position={line.position}
        aria-label={`${line.label} Progress Line`}
        aria-valuenow={line.position}
      >
        <SubText color='darkGreen' align='center' noWrap>
          {line.label}
        </SubText>
      </MultiProgressLineStyled>
    )
  })
}

export const MultiProgress = memo((props: IMultiProgressProps) => {
  const { height, lines = [] } = props

  const children = Children.map(
    props.children,
    (child: ReactElement<IProgressProps>) => {
      if (child?.type === Progress) {
        const value = child.props.value

        return (
          <MultiProgressBarStyled width={value} className='multiprogress-bar'>
            {cloneElement(child, {
              value: 100,
              variant: 'determinate',
            })}
          </MultiProgressBarStyled>
        );
      }
    }
  )

  return (
    <MultiProgressStyled height={height}>
      <div className='progress-bar-container'>{children}</div>
      {renderMultiProgressLines(lines)}
    </MultiProgressStyled>
  )
})

MultiProgress.displayName = 'MultiProgress'
